import { EColors } from "common/styles";
import { Styled } from "components/Styled";
import styled from "styled-components";

export const StyledQualityWrapper = styled(Styled.ContainerWrapper)`
display:flex;
flex-direction:column-reverse;


@media screen and (min-width: 1000px) {
   flex-direction:row;
   align-items: flex-start;
}
@media screen and (min-width: 1440px) {
  align-items: flex-end;  
}
`

export const StyledTitle = styled(Styled.H2)`
hyphens: auto;
word-wrap: break-word;
@media screen and (max-width: 999px) {
    display:none;
}
`

export const StyledTitleMob = styled(Styled.H2)`
@media screen and (min-width: 1000px) {
 display:none;
}
`

